import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import './Factbox.scss';
import img from '../../assets/fact.png';

function FactBox() {
  const copyBox = useRef();
  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: copyBox.current,
        start: 'top 75%',
        end: 'top 75%',
        once: true
      }
    });
    tl.fromTo(
      '#key',
      {
        opacity: 0
      },
      { opacity: 1, duration: 1 }
    );
  }, []);
  return (
    <figure className="factBox">
      <div className="factBox-contents">
        <img src={img} alt="" className="factBox-img" />
        <div className="factBox-copy" ref={copyBox}>
          <svg
            id="keyIcon"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52.22 50"
            className="factBox-icon"
          >
            <rect className="cls-1F" x="4.39" y="17.39" width="43.45" height="32.61" rx="1.88" />
            <path
              className="cls-2F"
              d="M16.12,17.39H37.88V10.87H16.12ZM50.94,0H3.06A2.17,2.17,0,0,0,.89,2.17V8.7a2.17,2.17,0,0,0,2.17,2.17h8.71v6.52H7.42a2.18,2.18,0,0,0-2.18,2.18V47.83A2.17,2.17,0,0,0,7.42,50H46.58a2.17,2.17,0,0,0,2.18-2.17V19.57a2.18,2.18,0,0,0-2.18-2.18H42.23V10.87h8.71A2.17,2.17,0,0,0,53.11,8.7V2.17A2.17,2.17,0,0,0,50.94,0Z"
              transform="translate(-0.89)"
            />
            <path
              className="cls-3F"
              d="M33.79,25.82A6.51,6.51,0,0,0,23.3,33.23l-6,6a2.17,2.17,0,0,0,0,3.07,2.17,2.17,0,0,0,3.08,0L23,39.66l1.54,1.54a2.18,2.18,0,0,0,3.08-3.08L26.1,36.58l.28-.28a6.56,6.56,0,0,0,2.8.65,6.49,6.49,0,0,0,4.61-1.9h0a6.53,6.53,0,0,0,0-9.23ZM30.71,32h0a2.17,2.17,0,1,1-3.07-3.07,2.16,2.16,0,0,1,3.07,0,2.16,2.16,0,0,1,0,3.07Z"
              transform="translate(-0.89)"
              id="key"
            />
          </svg>
          <p className="factBox-copy--title">2021: a record-breaking market for sellers</p>
          <p className="factBox-copy--body">
            In 2021, homes sold in a median of 1 week in every region of the United States in 2021 -
            the shortest time on market since NAR began tracking this statistic in 1989.
          </p>
          <p className="factBox-copy--body">
            For comparison, from 1989-2021, the average median time a home spent on market was 6
            week.
          </p>
          <p className="factBox-copy--body">
            Sellers typically received 100% of their list price for the homes they sold. This is the
            highest median percentage NAR started compiling this data in 2002.
          </p>
          <p className="factBox-copy--body italic">
            Take a deeper look at{' '}
            <a
              className="hyperLink mapLink"
              href="https://sponsorcontent.cnn.com/interactive/nar/map/"
              target="_blank"
              rel="noreferrer"
            >
              The State of Housing in America
            </a>{' '}
            with NAR’s interactive map featuring insights on 173 metro areas across the country.
          </p>
        </div>
      </div>
      <figcaption className="captions">Source: NAR research</figcaption>
    </figure>
  );
}

export default FactBox;
